import { trackHeapEvent } from '../../trackHeapEvent'

export enum WebsitesSocialMediaHeapEvents {
  saveSingle = 'location-details-save-single-websites-social-media',
  saveMultiple = 'location-details-save-multiple-websites-social-media',
}
interface ActionsWebsitesCommonProps {
  field: string
}

export interface SaveSingleWebsitesDataProps extends ActionsWebsitesCommonProps {
  status: 'Success' | 'Fail'
  storeLocationId: string
}

export interface SaveMultipleWebsitesDataProps extends ActionsWebsitesCommonProps {
  status: 'Success' | 'Fail'
  storeLocationsCount: string
}

export interface CancelSingleWebsitesDataProps extends ActionsWebsitesCommonProps {
  storeLocationId: string
}

export interface CancelMultipleWebsitesDataProps extends ActionsWebsitesCommonProps {
  storeLocationsCount: string
}

export const websitesSocialMediaTrackingEvents = {
  saveForSingleLocation(data: SaveSingleWebsitesDataProps) {
    trackHeapEvent(WebsitesSocialMediaHeapEvents.saveSingle, data)
  },

  saveForMultipleLocations(data: SaveMultipleWebsitesDataProps) {
    trackHeapEvent(WebsitesSocialMediaHeapEvents.saveMultiple, data)
  },

  cancelForSingleLocation(data: CancelSingleWebsitesDataProps) {
    trackHeapEvent(
      WebsitesSocialMediaHeapEvents.saveSingle,
      Object.assign(
        {
          status: 'Canceled',
        },
        data,
      ),
    )
  },

  cancelForMultipleLocations(data: CancelMultipleWebsitesDataProps) {
    trackHeapEvent(
      WebsitesSocialMediaHeapEvents.saveMultiple,
      Object.assign(
        {
          status: 'Canceled',
        },
        data,
      ),
    )
  },
}
